import React from 'react';

import ToDoHeader from './todo-header';
import ToDoAddSearch from './todo-search';
import ToDoList from './todo-list';
import Filter from './filter';


class App extends React.Component{


    minid=0;
    uniqueId=[1,2,3];

    createItem=(label)=>{
        return {
            label,
            important: false,
            done:false,
            id: ++this.minid, 
            visible: true
        }
    }
    createFilter=(label ,name, bool)=>{
        return{
            label,
            name,
            active: bool,
            key:++this.minid,
        }
    }
    // createId=()=>{
    //     let z=true;
    //     let rand;
    //     const isRand=(num , rand)=>{
    //         return num!==rand;
    //     }
    //     while(z===true){
    //         rand = 1 + Math.random() * (5 - 1)
    //         rand = Math.round(rand); 
    //         let bool=this.uniqueId.every((num)=>{
    //             return isRand(num , rand);
    //         });
    //         if(bool){
    //             this.uniqueId[z]=true;
    //             this.uniqueId.push(z);
    //             z=false;
    //         }
    //     }
    //     return rand;
       
    // }

    state={
        todolist:[
            this.createItem('Выпить чай'),
            this.createItem('Застелить постель'),
            this.createItem('Сделать Уроки'),
        ],
        status:[
            this.createFilter('All', 'all', true),
            this.createFilter('Active','important' , false),
            this.createFilter('Done','done' ,false),

        ]
    }



    addItem=(text)=>{
        this.setState(({todolist})=>{
            let arr=todolist.slice();
            arr.push(this.createItem(text));
            return{
                todolist:arr,
            }
        });
    }
    deleteItem=(id)=>{
        this.setState(({todolist})=>{
            let arr=todolist.filter((val)=>{
                 return val.id!==id;
             });
             return{
                 todolist:arr,
             }
         });
    }
    toggleImportant=(id)=>{
        this.setState(({todolist})=>{
            
            let arr=todolist.map((item)=>{
                if(item.id===id){
                    item.important=!item.important;
                }
                return item;
            });
            return {
              todolist: arr
            }
          }); 
    }
    toggleDone=(id)=>{
        this.setState(({todolist})=>{
            
            let arr=todolist.map((item)=>{
                if(item.id===id){
                    item.done=!item.done;
                }
                return item;
            });
            return {
              todolist: arr
            }
          }); 
    }
    todoSearch=(str)=>{
        
        this.setState(({todolist})=>{
            let arr=this.state.todolist.slice();
            

            arr.forEach((item , i)=>{
                if(str!==''){
                    if(item.label.indexOf(str) >-1){
                        item.visible=true;
                    }
                    else{
                        item.visible=false;
                    }    
                }
                else{
                    item.visible=true;
                }
            });
            

            return{
                todolist: arr
            }
        });
    }
    fielterList=(str)=>{
        let arr=this.state.todolist;
        if(str==='important'){
            arr.forEach((item)=>{
                if(item.important)
                    item.visible=true;
                else
                    item.visible=false; 
            });  
        }
        else if(str==='done'){
            arr.forEach((item)=>{
                if(item.done)
                    item.visible=true;
                else
                    item.visible=false;      
            });  
        }
        else{
            
            arr.forEach((item)=>{
                item.visible=true;
            });
        }
        this.setState({
            todolist:arr
        });
    }
    changeStatus=(str)=>{
        let arr_list=this.state.status.slice();
        this.setState(({status})=>{
        
            arr_list.forEach((elem , i)=>{
                if(elem.name===str){
                    elem.active=true;
                }
                else
                    elem.active=false;
            });
            return {
                status:arr_list
            }
       
        });
        this.fielterList(str);


    }
    render(){
        const {todolist}=this.state;
        const doneCount=todolist.filter((elem)=>elem.done).length;
        const todoCount=todolist.length-doneCount;



        return (
            <div className="todo-app">
              <ToDoHeader toDo={todoCount} done={doneCount} />
              <div className="top-panel d-flex">
                <ToDoAddSearch addListItem={this.addItem} todoSearch={this.todoSearch}/>
               
              </div>
              <Filter changeStatus={this.changeStatus} status={this.state.status}/>
        
              <ToDoList todos={todolist}
              eventDelete={this.deleteItem}
              toggleImportant={this.toggleImportant}
              toggleDone={this.toggleDone}
              />

            </div>
          ); 
    }
}

export default App;